import { useQuery } from '@apollo/client'
import { y00tsMutualCollections } from 'apollo/client'
import gql from 'graphql-tag'
import { useMemo } from 'react'
import { notEmpty } from 'utils'

export const QUERY_Y00TS_STATS = gql`
  query records {
    records {
        nft_contract_address,
        collection,
        mutual_count
    }
  }
`

interface y00tsStatsData {
    records: {
        nft_contract_address: string
        collection: string
        mutual_count: number
    }[]
}

/**
 * Fetch matic current price
 */

export function useZettaMutualCollections(): {
    loading: boolean
    error: boolean,
    records: {
        nft_contract_address: string
        collection: string
        mutual_count: number
    }[] | undefined
} {
    const { loading, error, data } = useQuery<y00tsStatsData>(QUERY_Y00TS_STATS, {
        client: y00tsMutualCollections,
        fetchPolicy: 'cache-first',
    })
    const formattedData = useMemo(() => {
        if (data) {
            return data.records
                .map((p) => {
                    return {
                        nft_contract_address: p.nft_contract_address,
                        collection: p.collection,
                        mutual_count: p.mutual_count,
                    }
                })
                .filter(notEmpty)
        } else {
            return undefined
        }
    }, [data])

    return {
        loading: loading,
        error: Boolean(error),
        records: formattedData,
    }
}
